<div class="container">
	<div class="container-body">
		<div class="row" style="margin-bottom: 30px;">
			<div class="col-6" style="font-size: 2em;">
				<i class="fa fa-group"></i>&nbsp;&nbsp;{{ getTitle() }}</div>
			<div class="col-4">

				<i *ngIf="isActive()" class="fa fa-user fa-2x userIconFilterCurrent"
					title="{{ modelService.getString('list_user_filter_active') }}">
					<i class="fa fa-check" style="color: green"></i>
				</i>
				<i *ngIf="!isActive()" class="fa fa-user fa-2x userIconFilter userActive"
					title="{{ modelService.getString('list_user_filter_active') }}" (click)="changeFilter(1)">
					<i class="fa fa-check"></i>
				</i>

				<i *ngIf="isDisable()" class="fa fa-user fa-2x userIconFilterCurrent"
					title="{{ modelService.getString('list_user_filter_disable') }}">
					<i class="fa fa-ban" style="color:red"></i>
				</i>
				<i *ngIf="!isDisable()" class="fa fa-user fa-2x userIconFilter userDisable"
					title="{{ modelService.getString('list_user_filter_disable') }}" (click)="changeFilter(0)">
					<i class="fa fa-ban"></i>
				</i>

				<i *ngIf="isWait()" class="fa fa-user fa-2x userIconFilterCurrent"
					title="{{ modelService.getString('list_user_filter_wait') }}">
					<i class="fa fa-clock-o" style="color:blueviolet"></i>
				</i>
				<i *ngIf="!isWait()" class="fa fa-user fa-2x userIconFilter userWait"
					title="{{ modelService.getString('list_user_filter_wait') }}" (click)="changeFilter(2)">
					<i class="fa fa-clock-o"></i>
				</i>

				<i *ngIf="isDelete()" class="fa fa-user fa-2x userIconFilterCurrent"
					title="{{ modelService.getString('list_user_filter_delete') }}">
					<i class="fa fa-close" style="color: red"></i>
				</i>
				<i *ngIf="!isDelete()" class="fa fa-user fa-2x userIconFilter userDelete"
					title="{{ modelService.getString('list_user_filter_delete') }}" (click)="changeFilter(3)">
					<i class="fa fa-close"></i>
				</i>

			</div>
			<div class="col-2 text-right">
				<i *ngIf="modelService.getUser().isAdmins" class="fa fa-user-plus fa-2x addUser"
				(click)="addUser()" title="{{ modelService.getString('list_user_add_user') }}"></i>
			</div>
		</div>
		<!--h1><i class="fa fa-group fa-2x"></i>&nbsp;&nbsp;{{ modelService.getString('menu_user_list') }}</h1-->
		<div class="tableUsers">
			<table>
				<tr>
					<th class="col1">{{ modelService.getString('user_list_name') }}</th>
					<th class="col2"> {{ modelService.getString('user_list_email') }} </th>
					<th class="col3"> {{ modelService.getString('user_list_company') }} </th>
					<th class="col4"> {{ modelService.getString('user_list_number') }} </th>
					<th *ngIf="isDelete()" class="col5"> {{ modelService.getString('user_list_projects') }} </th>
					<th class="col6"> &nbsp;</th>
				</tr>
				<tr *ngFor="let user of userListService.userList;let i=index;" [class.alt]="i%2===0">
					<td class="col1">&nbsp;
						<i *ngIf="user.rol===11" class="fa fa-user-circle-o" style="color:red;" title="{{modelService.getString('list_user_super')}}"></i>
						<i *ngIf="user.rol===1" class="fa fa-user-circle-o" title="{{modelService.getString('list_user_admin')}}"></i>
						<i *ngIf="user.rol===0" class="fa fa-user" style="color:grey;" title="{{modelService.getString('list_user_user')}}"></i>
						<i *ngIf="user.rol===10" class="fa fa-user" title="{{modelService.getString('list_user_boss')}}"></i>
						&nbsp;&nbsp;{{ user.apellidos + ', ' + user.nombre }} </td>
					<td class="col2">{{ user.email }} </td>
					<td class="col3">{{ user.empresa }}</td>
					<td class="col4">{{ user.numCliRivisa }}</td>
					<td *ngIf="isDelete()" class="col5">{{ (user.projects)? user.projects: 0 }}</td>
					<!--td class="col5">
						{{ user.estado == 1 ? modelService.getString('user _list_activated') : modelService.getString('user _list_deactivated') }}
					</td-->
					<td class="col6">
						<button *ngIf="isDisable()" class="btn btn-secondary" (click)="validateUser(user)">
							<i class="fa fa-ban fa-2x colorRojo"></i>
						</button>
						<button *ngIf="isActive()" class="btn btn-secondary" (click)="removeUser(user)">
							<i class="fa fa-check fa-2x colorVerde"></i>
						</button>
						<button class="btn btn-secondary" (click)="editUser(user)">
							<i class="fa fa-edit fa-2x"></i>
						</button>
					</td>
				</tr>
			</table>
		</div>
		<!--div class="user-count">{{ modelService.getString('user_list_total') }} : {{ userListService.totalUsers }} </div>
		<div class="user-count">{{ modelService.getString('user_list_active') }} : {{ userListService.activeUsers }} </div-->
		<div class="row" style="padding-top: 10px;">
			<div class="col">
				<i class="fa fa-user fa-2x userIconCount userIconCount"
					title="{{ modelService.getString('list_user_total_user') }}">
				</i>
				<span class="badge badge-pill badge-dark">{{userListService.totalUsers}}</span>&nbsp;&nbsp;

				<i class="fa fa-check userIconCount" style="color: green"
					title="{{ modelService.getString('list_user_filter_active') }}">
				</i>
				<span class="badge badge-pill badge-secondary"
					title="{{ modelService.getString('list_user_filter_active') }}">{{userListService.activeUsers}}</span>&nbsp;

				<i class="fa fa-ban userIconCount" style="color:red"
					title="{{ modelService.getString('list_user_filter_disable') }}">
				</i>
				<span class="badge badge-pill badge-secondary"
				title="{{ modelService.getString('list_user_filter_disable') }}">{{userListService.desactiveUsers}}</span>&nbsp;

				<i class="fa fa-clock-o userIconCount" style="color:blueviolet"
					title="{{ modelService.getString('list_user_filter_wait') }}">
				</i>
				<span class="badge badge-pill badge-secondary"
				title="{{ modelService.getString('list_user_filter_wait') }}">{{userListService.waitUsers}}</span>&nbsp;

				<i class="fa fa-close userIconCount" style="color: red"
					title="{{ modelService.getString('list_user_filter_delete') }}">
				</i>
				<span class="badge badge-pill badge-secondary"
				title="{{ modelService.getString('list_user_filter_delete') }}">{{userListService.deleteUsers}}</span>
			</div>
			<div class="col">
				<nav aria-label="Page navigation example">
					<ul *ngIf="getPages()" class="pagination justify-content-end">

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="firstPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-left" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="previousPage()" style="cursor: pointer;">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</a>
						</li>

						<li *ngFor="let item of btnsPage" class="page-item">
							<a *ngIf="item.page > -1 && item.page !== currentPage" class="page-link"  (click)="paginate(item.page)" style="cursor: pointer;">
								<span aria-hidden="true">{{item.text}}</span>
							</a>
							<a *ngIf="item.page === currentPage || item.page === -1" class="page-link" style="cursor: default;">
								<span aria-hidden="true" style="color: black;"><strong>{{item.text}}</strong></span>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Next" (click)="nextPage()" style="cursor: pointer;">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item" [title]="totalPage">
							<a class="page-link" aria-label="Next" (click)="lastPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-right" aria-hidden="true"></i>
							</a>
						</li>

					</ul>
				</nav>
			</div>
		</div>
	</div>
</div>

<!--app-alert #alertWindow></app-alert-->
